<template>
    <steps-manager>
        <template #step>
            <div class="data-validation">
                <div class="content">
                    Faça a verificação de todas as informações do cliente.
                    Documentações e informações importantes para a geração de contrato.
                    Se tudo estiver correto. Clique em aprovar pasta.
                </div>

                <ui-button
                    :loading="load"
                    design="md success mw-150"
                    @click="approveHandler">
                    Aprovar Pasta
                </ui-button>
            </div>
        </template>
    </steps-manager>
</template>

<script>
	import { uiButton } from '@/components/ui/buttons'
    import stepsManager from '../components/steps-manager'

    import { launchDay } from '@/services/axios'

    import { mapGetters } from 'vuex'

    export default {
        name: 'ui-validation',

        components: {
            stepsManager,
            uiButton
        },

        data() {
            return {
                load: false
            }
        },

        computed: {
            ...mapGetters('launchDay', {
                control: 'getControl',
                definitions: 'getDefinitions'
            })
        },

        methods: {
            /**
             * Event handler que trata o evento de quando a aprovação da pasta de um cliente
             * é solicitada
             */
            approveHandler() {
                if (!(this.definitions && this.control && this.control.deal)) return

                this.load = true
                const params = {
                    model: 'Deal_Main',
                    id: this.control.deal.id,
                    points_id: this.definitions.launchday_point_id
                }
                launchDay.create('checkin', params)
                    .then(response => {
                        this.$toastr.s(response.data.msg)
                    })
                    .catch(error => {
                        if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                        console.log(error)
                    })
                    .finally(() => {
                        this.load = false
                    })
            }
        }
    }
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>